import type { EditorThemeClasses } from 'lexical';

const editorTheme: EditorThemeClasses = {
	ltr: "ltr",
	rtl: "rtl",
	placeholder: "editor-placeholder",
	text: {
		bold: "font-bold",
		italic: "italic",
		underline: "underline",
		strikethrough: "line-through",
		underlineStrikethrough: "line-through underline",
		code: 'PlaygroundEditorTheme__textCode',
		// subscript: '',
		// superscript: '',
	},
	code: 'editor-code',
	codeHighlight: {
		atrule: 'PlaygroundEditorTheme__tokenAttr',
		attr: 'PlaygroundEditorTheme__tokenAttr',
		boolean: 'PlaygroundEditorTheme__tokenProperty',
		builtin: 'PlaygroundEditorTheme__tokenSelector',
		cdata: 'PlaygroundEditorTheme__tokenComment',
		char: 'PlaygroundEditorTheme__tokenSelector',
		class: 'PlaygroundEditorTheme__tokenFunction',
		'class-name': 'PlaygroundEditorTheme__tokenFunction',
		comment: 'PlaygroundEditorTheme__tokenComment',
		constant: 'PlaygroundEditorTheme__tokenProperty',
		deleted: 'PlaygroundEditorTheme__tokenProperty',
		doctype: 'PlaygroundEditorTheme__tokenComment',
		entity: 'PlaygroundEditorTheme__tokenOperator',
		function: 'PlaygroundEditorTheme__tokenFunction',
		important: 'PlaygroundEditorTheme__tokenVariable',
		inserted: 'PlaygroundEditorTheme__tokenSelector',
		keyword: 'PlaygroundEditorTheme__tokenAttr',
		namespace: 'PlaygroundEditorTheme__tokenVariable',
		number: 'PlaygroundEditorTheme__tokenProperty',
		operator: 'PlaygroundEditorTheme__tokenOperator',
		prolog: 'PlaygroundEditorTheme__tokenComment',
		property: 'PlaygroundEditorTheme__tokenProperty',
		punctuation: 'PlaygroundEditorTheme__tokenPunctuation',
		regex: 'PlaygroundEditorTheme__tokenVariable',
		selector: 'PlaygroundEditorTheme__tokenSelector',
		string: 'PlaygroundEditorTheme__tokenSelector',
		symbol: 'PlaygroundEditorTheme__tokenProperty',
		tag: 'PlaygroundEditorTheme__tokenProperty',
		url: 'PlaygroundEditorTheme__tokenOperator',
		variable: 'PlaygroundEditorTheme__tokenVariable',
	},
	// list: {
	// 	// listitem: 'PlaygroundEditorTheme__listItem',
	// 	nested: {
	// 		listitem: 'PlaygroundEditorTheme__nestedListItem',
	// 	},
	// 	olDepth: [
	// 		'PlaygroundEditorTheme__ol1',
	// 		'PlaygroundEditorTheme__ol2',
	// 		'PlaygroundEditorTheme__ol3',
	// 		'PlaygroundEditorTheme__ol4',
	// 		'PlaygroundEditorTheme__ol5',
	// 	],
	// 	ul: 'PlaygroundEditorTheme__ul',
	// },
	image: 'editor-image',
	inlineImage: 'inline-editor-image',
	blockCursor: 'blockCursor',
	quote: 'editor-quote',
};

export default editorTheme;
